<template>
  <div class="signupContent">
    <div class="split right">
      <div class="signupForm">
        <SignupForm :isMobile="isMobile" />
      </div>
    </div>
    <div class="split left">
      <div id="form_description" class="signupText">
        <h2 v-if="!isMobile">
          Pledge to Vote
        </h2>
        <p>
          One thing is for sure — no matter the shape of your district, no matter how much (or how little) it’s changed over time, and no matter how representative it is, it’s never been more important to show up to vote. Pledge to be an ACLU Voter this year — vote up and down the ballot for civil rights and civil liberties.
        </p>
        <p>
          We’ll equip you with candidate scorecards, registration deadlines, your polling locations, as well as ways to take action — so that you're heard and counted. Pledge to be an ACLU Voter today.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SignupForm from './SignupForm';

export default {
  name: 'SignupContent',
  components: {
    SignupForm
  },
  props: ['isMobile'],
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.signupText {
  padding: 2vh 3vw;
}
.signupForm {
  margin: 4vh 0 2vh;
  padding: 0 3vw;
  border-left: $border;
}

.mq-mobile {
  .signupText {
    padding: 0.5em 1em 1em;
  }
  .signupForm {
    padding: 0.5em 0 1em;
    margin: 0 1em;
    border-left: none;
    border-bottom: $border;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignupContent.vue